"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isInAppBrowser = exports.loadScript = void 0;
async function loadScript(url) {
    return new Promise((resolve, reject) => {
        const scriptElement = document.createElement("script");
        scriptElement.setAttribute("type", "text/javascript");
        scriptElement.src = url;
        scriptElement.onload = function () {
            resolve(true);
            scriptElement.parentNode?.removeChild(scriptElement);
        };
        scriptElement.onerror = function () {
            reject("Fehler beim Laden des Scriptes");
            scriptElement.parentNode?.removeChild(scriptElement);
        };
        document.body.appendChild(scriptElement);
    });
}
exports.loadScript = loadScript;
const inAppBrowserIndicators = [
    "fb_iab",
    "fban",
    "fbav",
    "gsa",
    "instagram",
    "linkedinapp",
    "messenger",
    "pinterest",
    "snapchat",
    "bytelocale",
    "bytedancewebview",
    "twitter",
    "whatsapp",
    "youtube",
];
function isInAppBrowser() {
    const lowerCasedUA = (navigator.userAgent || "").toLowerCase();
    return inAppBrowserIndicators.some((indicator) => lowerCasedUA.includes(indicator));
}
exports.isInAppBrowser = isInAppBrowser;
